export default {
    getHeaderFields: state => state.headerFields,
    getFormHeaderFields: state => state.formHeaderFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
    getDataTableOptions: state => state.dataTableOptions,
    isExcelImportFormOpen: state => state.excelImportFormIsOpen,
    getExcelImportHeaderFields: state => state.excelImportHeaderFields,
    getExcelImportFormActions: state => state.excelImportFormActions,
}
